if (!customElements.get('payment-widgets')) {
  class PaymentWidgets extends HTMLElement {
    constructor() {
      super();
      this.variantChangeUnsubscriber = undefined;
      this.cartUpdateUnsubscriber = undefined;
      this._aplazameObserver = undefined;
      this._klarnaObserver = undefined;
    }

    connectedCallback() {
      this.aplazameEl = this.querySelector('.payment-widgets__aplazame');
      this.klarnaEl = this.querySelector('.payment-widgets__klarna');
      this.updateVisibility(parseInt(this.dataset.price, 10));
      this._watchWidgetInjection();

      requestAnimationFrame(() => {
        if (window.Aplazame?.widget?.refresh) window.Aplazame.widget.refresh();
        if (window.Klarna?.OnsiteMessaging?.refresh) window.Klarna.OnsiteMessaging.refresh();
      });

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const price = event.data.variant ? event.data.variant.price : null;
        if (price === null || price === undefined) return;

        this.dataset.price = price;

        const klarnaPlacement = this.querySelector('klarna-placement');
        if (klarnaPlacement) klarnaPlacement.setAttribute('data-purchase-amount', price);

        const aplazameWidget = this.querySelector('[data-aplazame-widget-instalments]');
        if (aplazameWidget) {
          aplazameWidget.setAttribute('data-amount', price);
          if (window.Aplazame?.widget?.refresh) window.Aplazame.widget.refresh();
        }

        this.updateVisibility(price);
      });

      if (this.dataset.context === 'cart') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const price = event.cartData?.total_price;
          if (price == null) return;

          this.dataset.price = price;

          const klarnaPlacement = this.querySelector('klarna-placement');
          if (klarnaPlacement) klarnaPlacement.setAttribute('data-purchase-amount', price);

          const aplazameWidget = this.querySelector('[data-aplazame-widget-instalments]');
          if (aplazameWidget) {
            aplazameWidget.setAttribute('data-amount', price);
            if (window.Aplazame?.widget?.refresh) window.Aplazame.widget.refresh();
          }

          this.updateVisibility(price);

          if (window.Klarna?.OnsiteMessaging?.refresh) window.Klarna.OnsiteMessaging.refresh();
        });
      }
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      if (this._aplazameObserver) this._aplazameObserver.disconnect();
      if (this._klarnaObserver) this._klarnaObserver.disconnect();
    }

    _watchWidgetInjection() {
      const aplazameTarget = this.querySelector('[data-aplazame-widget-instalments]');
      if (aplazameTarget && this.aplazameEl) {
        this._aplazameObserver = new MutationObserver(() => {
          if (aplazameTarget.querySelector('.aplazame-widget')) {
            this.aplazameEl.classList.add('is-widget-ready');
            this._aplazameObserver.disconnect();
          }
        });
        this._aplazameObserver.observe(aplazameTarget, { childList: true, subtree: true });
      }

      const klarnaTarget = this.querySelector('klarna-placement');
      if (klarnaTarget && this.klarnaEl) {
        this._klarnaObserver = new MutationObserver(() => {
          if (klarnaTarget.childNodes.length > 0) {
            this.klarnaEl.classList.add('is-widget-ready');
            this._klarnaObserver.disconnect();
          }
        });
        this._klarnaObserver.observe(klarnaTarget, { childList: true, subtree: true });
      }
    }

    updateVisibility(price) {
      const aplazameEnabled = this.dataset.aplazameEnabled === 'true';
      const klarnaEnabled = this.dataset.klarnaEnabled === 'true';
      const aplazameMin = parseInt(this.dataset.aplazameMin, 10);
      const aplazameMax = parseInt(this.dataset.aplazameMax, 10);
      const klarnaMin = parseInt(this.dataset.klarnaMin, 10);
      const klarnaMax = parseInt(this.dataset.klarnaMax, 10);

      const showAplazame = aplazameEnabled && price >= aplazameMin && price <= aplazameMax;
      const showKlarna = klarnaEnabled && price >= klarnaMin && price <= klarnaMax;

      if (this.aplazameEl) this.aplazameEl.classList.toggle('is-hidden', !showAplazame);
      if (this.klarnaEl) this.klarnaEl.classList.toggle('is-hidden', !showKlarna);
    }
  }

  customElements.define('payment-widgets', PaymentWidgets);
}

(function () {
  function initDeferredPaymentBlocks() {
    var blocks = document.querySelectorAll('[data-deferred-payment]');
    if (!blocks.length) return;

    function updateAll(price) {
      blocks.forEach(function (el) {
        var type = el.dataset.deferredPayment;
        var enabledKey = type + 'Enabled';
        var minKey = type + 'Min';
        var maxKey = type + 'Max';
        var enabled = el.dataset[enabledKey] === 'true';
        var min = parseInt(el.dataset[minKey] || '0', 10);
        var max = parseInt(el.dataset[maxKey] || '0', 10);
        el.classList.toggle('is-hidden', !(enabled && price >= min && price <= max));
      });
    }

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var price = event.data && event.data.variant ? event.data.variant.price : null;
        if (price !== null && price !== undefined) updateAll(price);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeferredPaymentBlocks);
  } else {
    initDeferredPaymentBlocks();
  }
})();

(function () {
  function watchCartFooter() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var observer = new MutationObserver(function () {
      requestAnimationFrame(function () {
        if (window.Aplazame && window.Aplazame.widget && window.Aplazame.widget.refresh) {
          window.Aplazame.widget.refresh();
        }
        if (window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh) {
          window.Klarna.OnsiteMessaging.refresh();
        }
      });
    });
    observer.observe(footer, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartFooter);
  } else {
    watchCartFooter();
  }
})();
